import * as React from 'react';
import { Button } from './ui';
import { useWallet } from './WalletContext';

const GuardButton = ({ onClick, children, ...rest }: any) => {
  return (
    <Button onClick={onClick} margin="40px auto" {...rest}>
      {children}
    </Button>
  );
};

const ConnectedWalletGuard: React.FC<any> = ({
  children,
  networkId,
  hideButton = false,
  ...rest
}) => {
  const { address, selectWallet, network, switchNetwork, isMetaMask } = useWallet();

  if (!address) {
    return (
      <GuardButton onClick={selectWallet} {...rest}>
        Connect Wallet
      </GuardButton>
    );
  }

  if (!address && hideButton) {
    return null;
  }

  if (networkId && networkId !== network) {
    return (
      <GuardButton disabled={!isMetaMask()} onClick={() => switchNetwork(networkId)} {...rest}>
        Switch Network
      </GuardButton>
    );
  }

  return children;
};

export default ConnectedWalletGuard;
